import { get as _get } from 'lodash';

const formatLocation = (location = {}) => {
  return `${_get(location, 'street1')}, ${_get(location, 'city')}, ${_get(location, 'state')} ${_get(location, 'zip')}`;
};

export default formatLocation;
